import { render, staticRenderFns } from "./ServicePrice.vue?vue&type=template&id=d51ddeee&scoped=true&"
import script from "./ServicePrice.vue?vue&type=script&lang=js&"
export * from "./ServicePrice.vue?vue&type=script&lang=js&"
import style0 from "./ServicePrice.vue?vue&type=style&index=0&id=d51ddeee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d51ddeee",
  null
  
)

export default component.exports